import { Injectable } from '@angular/core';
import { RoleData } from '../model';
import { BaseService } from '../../shared/baseService';
@Injectable({
    providedIn: 'root'
})

export class RoleDatasService extends BaseService<RoleData> {
  
    constructor() {
        super('RoleData');
    }
}
